module.exports = __webpack_public_path__ + "img/arms_armsworldmag.66522ff.png";